import React, { useEffect, useState } from "react";
import "./portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";

const API_BASE = "https://portfolio-backend-production-832f.up.railway.app/api";

const Portfolio = () => {
  const [Data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [popupData, setPopupData] = useState(null); // 🔹 modal state

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch(`${API_BASE}/projects`);
        const data = await res.json();
        setData(data);
        setFilteredData(data);

        // Extract unique categories
        const uniqueCats = ["All", ...new Set(data.map((item) => item.category))];
        setCategories(uniqueCats);
      } catch (err) {
        console.error("Error fetching projects:", err);
      }
    };
    fetchProjects();
  }, []);

  const handleFilter = (category) => {
    setActiveCategory(category);
    if (category === "All") setFilteredData(Data);
    else setFilteredData(Data.filter((item) => item.category === category));
  };

  return (
    <section className="Portfolio" id="portfolio">
      <h2 className="section__title">Portfolio</h2>
      <span className="section__subtitle">My Work</span>

      {/* Category Filter Buttons */}
      <div className="portfolio__filters">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`filter-btn ${activeCategory === cat ? "active" : ""}`}
            onClick={() => handleFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Swiper Carousel */}
      <Swiper
        className="row"
        loop={false}
        spaceBetween={24}
        pagination={{ clickable: true }}
        breakpoints={{
          576: { slidesPerView: 2 },
          768: { slidesPerView: 2, spaceBetween: 48 },
        }}
        modules={[Pagination]}
      >
        {filteredData.map(({ id, image, title, description, link, details }) => (
          <SwiperSlide className="card" key={id}>
            <div className="face face1">
              <div className="content">
                <img
                  src={image || "/assets/project.png"}
                  alt=""
                  className="testimonial__img"
                />
              </div>
            </div>
            <div className="face face2">
              <div className="content">
                <h3 className="testimonial__name">{title}</h3>
                <p className="testimonial__description">{description}</p>

                <div className="portfolio__links">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href="#"
                    className="home__social-icon"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Demo
                  </a>
                  <a
                    href={link}
                    className="home__social-icon"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="uil uil-github-alt"> Github</i>
                  </a>
                  <button
                    className="more-info-btn"
                    onClick={() => setPopupData({ title, details })}
                  >
                    ▼ More Info
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* 🔹 Modal Popup */}
      {popupData && (
        <div className="modal-overlay" onClick={() => setPopupData(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{popupData.title}</h3>
            <p>{popupData.details || "No additional details available."}</p>
            <button className="close-btn" onClick={() => setPopupData(null)}>
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
